import { Grid as a } from "./atoms-v216.js";
import { Column as t } from "./atoms-v212.js";
import { Base as n } from "./atoms-v2777.js";
import { breakpoints as d } from "./atoms-v2125.js";
import r from "styled-components";
import { Text as s } from "./atoms-v243.js";
import { Picture as p } from "./atoms-v233.js";
const b = r(a)`
  ${n}
`, y = r(t)`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${d.large} {
    flex-direction: row;
    gap: 32px;
  }
`, k = r.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
`, v = r.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  padding: 2px;
`, w = r.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  min-width: 0;

  > * {
    flex: 1;
    min-width: 0;
  }
`, R = r.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`, M = r.div`
  background-color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.surface.${o}.layer01`)};
  border-radius: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.radius.cardRadiusMed")}px;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  justify-content: center;

  @media ${d.small} {
    margin-top: 4px;
    padding: 16px;
  }

  @media ${d.medium} {
    margin-top: 8px;
    padding: 24px 32px;
  }

  @media ${d.large} {
    margin-top: 0;
    padding: 20px 24px;
  }
`, C = r.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`, P = r(s)`
  color: ${({ $colorTheme: o, theme: i }) => i == null ? void 0 : i.get(`tokens.text.${o}.primary`)};

  ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.productive")) == null ? void 0 : i.toJS();
}}

  @media ${d.xLarge} {
    ${({ theme: o }) => {
  var i;
  return (i = o == null ? void 0 : o.get("tokens.body.expressive")) == null ? void 0 : i.toJS();
}}
  }
`, T = r.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
`, j = r.div`
  display: flex;
  gap: 4px;
  height: 375px;
  width: 100%;
`, l = r(p)`
  > img {
    object-fit: cover;
  }

  ${({ $position: o, theme: i }) => o == "left" && `
    > img {
      border-top-left-radius: ${i == null ? void 0 : i.get("tokens.radius.cardRadiusMed")}px;
      border-bottom-left-radius: ${i == null ? void 0 : i.get("tokens.radius.cardRadiusMed")}px;
    }  
  `}

  ${({ $position: o, theme: i }) => o == "rightTop" && `
    > img {
      border-top-right-radius: ${i == null ? void 0 : i.get("tokens.radius.cardRadiusMed")}px;
    }  
  `}

  ${({ $position: o, theme: i }) => o == "rightBottom" && `
    > img {
      border-bottom-right-radius: ${i == null ? void 0 : i.get("tokens.radius.cardRadiusMed")}px;
    }  
  `}

  ${({ $position: o, theme: i }) => o == "center" && `
    > img {
      border-radius: ${i == null ? void 0 : i.get("tokens.radius.cardRadiusMed")}px;
    }  
  `}

  ${({ $position: o, theme: i }) => o == "leftTop" && `
    > img {
      border-top-left-radius: ${i == null ? void 0 : i.get("tokens.radius.cardRadiusMed")}px;
    }  
  `}

  ${({ $position: o, theme: i }) => o == "leftBottom" && `
    > img {
      border-bottom-left-radius: ${i == null ? void 0 : i.get("tokens.radius.cardRadiusMed")}px;
    }  
  `}

  ${({ $position: o, theme: i }) => o == "top" && `
    > img {
      border-top-left-radius: ${i == null ? void 0 : i.get("tokens.radius.cardRadiusMed")}px;
      border-top-right-radius: ${i == null ? void 0 : i.get("tokens.radius.cardRadiusMed")}px;
    }  
  `}
`, B = r(l)`
  flex: 1;
  object-fit: cover;
  width: 100%;
  ${({ $fixed: o }) => o && `
      height: calc((375px - 4px) / 2);
      flex: 0 0 auto;
    `}
`, L = r.div`
  align-items: center;
  display: flex;
  justify-content: center;
  text-align: center;
  width: 100%;
`;
export {
  b as BookingConfirmationHeader,
  w as BottomPictures,
  L as CenteredContent,
  y as ContentColumn,
  B as GrowingPicture,
  R as HeaderText,
  P as InformationLabel,
  M as InformationsList,
  C as InformationsListRow,
  T as MobileTextWrapper,
  k as PictureColumn,
  j as PictureMediumRow,
  l as RounderPicture,
  v as TextColumn
};
